module.exports = __webpack_public_path__ + "static/bridge-df9f0efdadbc4cb9be725f14a9f561dc.jpg";